import PropTypes from 'prop-types';

// eslint-disable-next-line no-unused-vars
import styles from './index.styl';


export default function GlobalStyles({ theme }) {
  return (
    <>
      <style jsx global>{`
        .lb-skeleton
          background ${theme.controls.skeleton.background}
      `}</style>
      {/**
       * animation-name в .styl-файлах всегда преобразуется в
       * уникальное название, и :global с ним не работает.
       * Поэтому кладём в jsx всё, связанное с animation-name.
       */}
      <style jsx global>{`
        .lb-skeleton:after
          animation shimmer 2s infinite
        @keyframes shimmer
          100%
            transform translateX(100%)
      `}</style>
    </>
  );
}

GlobalStyles.propTypes = {
  theme: PropTypes.object,
};
